import React from 'react';

import { useCssHandles } from '../../../utils/functions';
import FormattedCurrency from '../../format-currency/FormattedCurrency';
import { useCurrentSeller } from '../SellerBody/CurrentSellerContext';

const SELLERS_CSS_HANDLES = ['sellerPrice'] as const;

function SellerPrice({ componentId, blockClass }: any) {
	const { currentSeller } = useCurrentSeller();
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SELLERS_CSS_HANDLES, blockClass);

	return (
		<p data-selection={componentId} className={`${handles.sellerPrice} items-center tc w-100-s w-20-m br2 ph6 pv4 ma0`}>
			<FormattedCurrency
				baseCssHandle={`vtex-seller-selector-0-x`}
				value={currentSeller ? currentSeller.commertialOffer.Price : 0}
			/>
		</p>
	);
}

export default SellerPrice;
